import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    IParams,
    RedirectParams,
} from '../../../../shared/types/redirectParams';
import { Param, ParamHistorical } from '../../../../shared/types/param';

import { FormikProps } from 'formik';
import {
    COMPLIANCE_TERMS,
    COMPLIANCE_TERMS_DETAIL,
} from '../../../../routes/paths';
import {
    asyncGetParam,
    asyncPatchtComplianceTerms,
    asyncPostParam,
    asyncGetComplianceTermsHistorical,
} from '../../../../services/param.service';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';

export const useComplianceTermsForm = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idComplianceTerm } = useParams();
    const [complianceTerms, setComplianceTerms] = useState<IParams>();
    const [loading, setLoading] = useState(false);
    const [formikComplianceTermsData, setformikComplianceTermsData] =
        useState<FormikProps<Param>>();

    const [complianceTermsHistorical, setComplianceTermsHistorical] =
        useState<ParamHistorical[]>();
    const isValidForm = formikComplianceTermsData?.isValid;

    const handleCleanAndBack = () => {
        formikComplianceTermsData?.resetForm();
        navigate(COMPLIANCE_TERMS);
    };

    const handleSubmit = async () => {
        await formikComplianceTermsData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: RedirectParams =
            formikComplianceTermsData?.values as RedirectParams;

        let res: any | undefined = undefined;

        try {
            if (complianceTerms && complianceTerms.id)
                res = await asyncPatchtComplianceTerms(
                    complianceTerms.id,
                    data
                );
            else res = await asyncPostParam(data);
        } catch (error) {}

        if (res?.items) {
            ToastSwal.fire({
                text: `¡Felicidades! El cumplimiento de términos se ${
                    complianceTerms && complianceTerms.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${COMPLIANCE_TERMS_DETAIL}/${res?.items?.id}`);
        } else {
            const message = `Lo sentimos, no se pudo 
            ${complianceTerms && complianceTerms.id ? 'actualizar' : 'crear'}
            el cumplimiento de términos. Por favor, asegúrate de ${
    res?.message !== 'PARAM-FAIL-DUPLICATED'
        ? 'diligenciar los datos correctamente'
        : 'que no exista previamente'
} e intenta nuevamente más tarde.`;

            ToastSwal.fire({
                text: message,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idComplianceTerm?.trim())) {
            setLoading(true);
            asyncGetParam(idComplianceTerm?.trim())
                .then((complianceTerms: any) => {
                    if (!complianceTerms || !complianceTerms.items)
                        navigate(COMPLIANCE_TERMS);
                    setComplianceTerms(complianceTerms?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idComplianceTerm]);

    useEffect(() => {
        if (Boolean(idComplianceTerm?.trim()) && showHistorical) {
            setLoading(true);

            asyncGetComplianceTermsHistorical(idComplianceTerm?.trim())
                .then((resp) => {
                    if (resp) setComplianceTermsHistorical(resp);
                    else navigate(COMPLIANCE_TERMS);
                })
                .finally(() => setLoading(false));
        }
    }, [idComplianceTerm, showHistorical]);

    return {
        complianceTerms,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setformikComplianceTermsData,
        complianceTermsHistorical,
    };
};
